// routes.js

import { APP_BASE_URL } from 'firebaseConfig';
import { SectionType } from 'utilities/Enums';

export const PUBLIC_APP_ORIGIN = APP_BASE_URL;

export const SECTION_PATHS = {
  [SectionType.HOME]: '/',
  [SectionType.FAVORITES]: '/favorites',
  [SectionType.TRASH]: '/trash',
  [SectionType.SEARCH]: '/search',
  [SectionType.STORE]: '/store',
  [SectionType.WORKSPACE]: '/api',
  [SectionType.INBOX]: '/inbox',
  [SectionType.CALENDAR]: '/calendar',
  [SectionType.CHANNELS]: '/channels',
  [SectionType.LIBRARY]: '/library',
  [SectionType.NOTIFICATIONS]: '/notifications',
  [SectionType.SETTINGS]: '/settings',
};

export const NODE_BASE_PATH = '/node';
export const PAGE_BASE_PATH = '/page';
export const TEMPLATE_BASE_PATH = '/template';
export const USER_BASE_PATH = '/user';
export const WORKSPACE_PROFILE_BASE_PATH = '/workspace';

export const buildNodePath = (nodeKey) => `${NODE_BASE_PATH}/${encodeURIComponent(nodeKey)}`;

export const buildAbsoluteNodeUrl = (nodeKey, origin = PUBLIC_APP_ORIGIN) => {
  const cleanOrigin = String(origin || PUBLIC_APP_ORIGIN)
    .trim()
    .replace(/\/+$/, '');
  const cleanNodeKey = String(nodeKey || '').trim();

  if (!cleanNodeKey) return cleanOrigin;
  return `${cleanOrigin}${buildNodePath(cleanNodeKey)}`;
};

export const buildProfilePath = (profileKey) =>
  profileKey ? `${USER_BASE_PATH}/${encodeURIComponent(profileKey)}` : USER_BASE_PATH;

export const buildWorkspaceMemberProfilePath = (workspaceKey, memberId) => {
  const normalizedWorkspaceKey = String(workspaceKey || '').trim();
  const normalizedMemberId = String(memberId || '').trim();

  if (!normalizedWorkspaceKey || !normalizedMemberId) {
    return WORKSPACE_PROFILE_BASE_PATH;
  }

  return `${WORKSPACE_PROFILE_BASE_PATH}/${encodeURIComponent(normalizedWorkspaceKey)}/profile/${encodeURIComponent(normalizedMemberId)}`;
};

export function getSectionPath(section, options = {}) {
  if (section === SectionType.USER && options.workspaceKey && options.memberId) {
    return buildWorkspaceMemberProfilePath(options.workspaceKey, options.memberId);
  }

  if (section === SectionType.USER && options.profileKey) {
    return buildProfilePath(options.profileKey);
  }

  if (section === SectionType.NODE && options.nodeKey) {
    return buildNodePath(options.nodeKey);
  }

  const path = SECTION_PATHS[section];
  return path || SECTION_PATHS[SectionType.HOME];
}

export function inferSectionFromPath(pathname) {
  if (!pathname || pathname === '/' || pathname === '') {
    return SectionType.HOME;
  }

  if (pathname.startsWith(`${NODE_BASE_PATH}/`)) {
    return SectionType.NODE;
  }

  if (pathname === PAGE_BASE_PATH || pathname.startsWith(`${PAGE_BASE_PATH}/`)) {
    return SectionType.WORKSPACE;
  }

  if (pathname === TEMPLATE_BASE_PATH || pathname.startsWith(`${TEMPLATE_BASE_PATH}/`)) {
    return SectionType.STORE;
  }

  if (pathname === USER_BASE_PATH || pathname.startsWith(`${USER_BASE_PATH}/`)) {
    return SectionType.USER;
  }

  if (pathname.startsWith(`${WORKSPACE_PROFILE_BASE_PATH}/`)) {
    return SectionType.USER;
  }

  if (pathname.startsWith(`${USER_BASE_PATH}/`)) {
    return SectionType.USER;
  }

  const match = Object.entries(SECTION_PATHS).find(([, basePath]) => {
    if (basePath === '/') return false;
    if (pathname === basePath) return true;
    return pathname.startsWith(`${basePath}/`);
  });

  return match ? match[0] : null;
}
